import React from "react";
import clsx from "clsx";
import useStyles from "./FundList.style";

export const FundListFilterItem = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const c = useStyles({});

  return (
    <div className={clsx(c.fundListFilterItem, className)}>{children}</div>
  );
};
